import React, { Component, PropTypes } from 'react';
import { DragSource } from 'react-dnd';
import { compose } from 'ramda';
import Target from './drop-target';

const dragSource = {
  beginDrag() {
    return {};
  },
  endDrag(props, monitor) {
    const dropResult = monitor.getDropResult();
    if (dropResult) {
      props.movedTo(dropResult.position);
    }
  },
};

const dragSourceFn = DragSource('DRAG_SOURCE', dragSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
}));
const Source = props => {
  const { isDragging, connectDragSource, children, style, className } = props;
  const opacity = isDragging ? 0.4 : 1;
  return (
    connectDragSource(
      <div style={{ ...style, opacity }} className={className}>
        {children}
      </div>,
    )
  );
};

Source.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  movedTo: PropTypes.func.isRequired,
};
export default compose(dragSourceFn)(Source);



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/dnd/drag-source.jsx